import apiTiposOS from "@/app/services/tiposos";
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
  namespaced: true,
  state: {
    tipoos: {
      id: '',
      descricao: '',
      comissao_peca: 'N',
      comissao_servico: 'N',
      cobra_peca: 'N',
      cobra_servico: 'N',
    },
    tiposos: [],
    busca: "",
    total_itens: 0,
    paginacao: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['descricao'],
      sortDesc: [false]
    }
  },

  mutations: {
    LISTAR(state, tiposos) {
      state.tiposos = tiposos;
    },

    ABRIR(state, tipoos) {
      state.tipoos = tipoos;
    },

    ADICIONAR(state, tipoos) {
      state.tiposos.push(tipoos);
    },

    ATUALIZAR(state, tipoos) {
      let index = state.tiposos.findIndex(peca_ => peca_.id == tipoos.id);
      if (index > -1) {
        state.tiposos.splice(index, 1, tipoos);
      }
    },

    EXCLUIR(state, id) {
      let index = state.tiposos.findIndex(tipoos => tipoos.id == id);
      if (index > -1) {
        state.tiposos.splice(index, 1);
      }
    },

    SET_BUSCA(state, busca) {
      state.busca = busca;
    },

    SET_PAGE(state, page) {
      state.paginacao.page = page;
    },

    SET_TOTAL_ITENS(state, total_itens) {
      state.total_itens = total_itens;
    },

    UPDATE_PAGINACAO(state, paginacao) {
      state.paginacao = paginacao;
    },

    ZERAR(state) {
      state.tipoos = {
        id: '',
        descricao: '',
        comissao_peca: 'N',
        comissao_servico: 'N',
        cobra_peca: 'N',
        cobra_servico: 'N'
      };
    }
  },

  actions: {
    async listar({ commit, state }) {
      commit('LOADING_ON', null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.paginacao;

      const paginacao = {
        page, 
        itemsPerPage,
        sortBy: sortBy[0], 
        sortDesc: sortDesc[0]
      }

      if (state.busca) {
        paginacao.busca = state.busca;
      }

      let response = await apiTiposOS.listar(paginacao);
      commit('LISTAR', response.data);
      commit('SET_TOTAL_ITENS', response.total);
      commit('LOADING_OFF', null, { root: true });
    },

    async abrir({ commit }, id) {
      commit('LOADING_ON', null, { root: true });
      let tipoos = await apiTiposOS.abrir(id);
      commit('ABRIR', tipoos);
      commit('LOADING_OFF', null, { root: true });
    },

    async salvar({ commit }, tipoos) {
      let novopeca = await apiTiposOS.salvar(tipoos);
      commit('ADICIONAR', novopeca);
    },

    async atualizar({ commit }, tipoos) {
      await apiTiposOS.atualizar(tipoos);
      commit('ATUALIZAR', tipoos);
    },

    async excluir({ commit }, id) {
      await apiTiposOS.excluir(id);
      commit('EXCLUIR', id);
    },

  }
}
